module.exports = __webpack_public_path__ + "img/5.bd6d8053.png";